/**
 * Supabase Configuration
 * 
 * SESマッチングシステムのSupabaseクライアント設定
 * データベース接続と認証の管理
 * 
 * @module SupabaseConfig
 */

import { createClient } from '@supabase/supabase-js';

// Supabaseプロジェクトの接続情報
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

// Supabaseクライアントインスタンス
export const supabase = createClient(supabaseUrl, supabaseKey);